import { jsx as _jsx } from "react/jsx-runtime";
import classes from './Select.module.css';
import { forwardRef } from 'react';
const Select = forwardRef(({ children, className = '', ...props }, ref) => {
    return (_jsx("select", { ref: ref, className: `${classes['uikit-select']} ${className}`, ...props, children: children }));
});
Select.displayName = 'Select';
export default Select;
//# sourceMappingURL=index.js.map